import React from 'react';

export interface LocationMarkerThickProps {
  className?: string;
}

const LocationMarkerThick: React.FC<LocationMarkerThickProps> = ({
  className,
}) => {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 32 39"
    >
      <filter
        id="a"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="86.2439"
        width="80"
        x="-24"
        y="-24"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_852_23322"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_852_23322"
          mode="normal"
          result="shape"
        />
      </filter>
      <g filter="url(#a)">
        <path
          clipRule="evenodd"
          d="m20.5255 20.3217c2.4994-2.4746 2.4994-6.4865 0-8.9611-2.4994-2.47458-6.5516-2.47455-9.051 0-2.49935 2.4746-2.49938 6.4865 0 8.9611l4.5255 4.4806zm6.7882 6.7208c6.2483-6.1863 6.2485-16.2162 0-22.40271-6.2485-6.18646-16.379-6.18632-22.62738 0-6.24836 6.18631-6.24849 16.21631 0 22.40271l11.31368 11.2014z"
          fill="#fff"
          fillOpacity=".3"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};

export default LocationMarkerThick;
